import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import { FlexWrap } from 'components/UIComponents/FormStyles'
import CheckIconWhite from 'components/icons/CheckIconWhite'
import React from 'react'
import { useParams } from 'react-router-dom'
import AddUserForm from './Partials'

const ShortListDrawer = ({
  form,
  shortListDrawer,
  setshortListDrawer,
  setNewPreviewDrawer,
  setNoticePeriod,
  setCandidateYear,
  setRating,
  handleCreate,
  errors,
  setErrors,
  applyFilter,
  setApplyFilter,
  count,
  appliedCandidatesListTrue,
  singleRoleData,
  rolesDegreeList,
  studentRating,
  setStudentRating,
  setDegreeDepartment,
  setDegreeDepartmentData,
  degreeDepartmentData,
  candidateRangeMin,
  setCandidateRangeMin,
  candidateRangeMax,
  setCandidateRangeMax,
  getAppliedCandidateListTrue,
  candidateIds,
  locationStatus,
  setLocationStatus,
  locationWiseFilterHanlder,
  prefferedlocationStatus,
  setPrefferedLocationStatus,
  setPrefferedLocations,
  prefferedLocations,
  setCurrentLocationStatus,
  selectedRows,
  setCitySave,
  citySave,
}) => {
  const params = useParams()
  const onClose = () => {
    setshortListDrawer(false)
    clearAll()
    form.resetFields()
  }

  const clearAll = () => {
    setStudentRating('')
    setNoticePeriod('')
    setCandidateYear('')
    setRating('')
    setCandidateRangeMax('')
    setDegreeDepartment('')
    setDegreeDepartmentData([])
    setPrefferedLocations([])
    setPrefferedLocationStatus(false)
    setCurrentLocationStatus(false)
    getAppliedCandidateListTrue({
      roleId: params?.jobId,
      candidateIds: candidateIds,
    })
    setApplyFilter(false)
    setErrors({
      cityError: '',
      institueError: '',
      filterError: '',
      poolCollegesError: '',
    })
  }

  const onSubmit = async formData => {
    setshortListDrawer(false)
    setNewPreviewDrawer(true)
  }
  const content = () => {
    return (
      <divForm>
        <AddUserForm
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          handleCreate={handleCreate}
          errors={errors}
          setNoticePeriod={setNoticePeriod}
          setCandidateYear={setCandidateYear}
          setRating={setRating}
          count={count}
          appliedCandidatesListTrue={appliedCandidatesListTrue}
          singleRoleData={singleRoleData}
          setErrors={setErrors}
          studentRating={studentRating}
          setStudentRating={setStudentRating}
          setDegreeDepartmentData={setDegreeDepartmentData}
          degreeDepartmentData={degreeDepartmentData}
          setDegreeDepartment={setDegreeDepartment}
          rolesDegreeList={rolesDegreeList}
          candidateRangeMin={candidateRangeMin}
          setCandidateRangeMin={setCandidateRangeMin}
          candidateRangeMax={candidateRangeMax}
          setCandidateRangeMax={setCandidateRangeMax}
          setLocationStatus={setLocationStatus}
          locationStatus={locationStatus}
          locationWiseFilterHanlder={locationWiseFilterHanlder}
          prefferedlocationStatus={prefferedlocationStatus}
          setPrefferedLocationStatus={setPrefferedLocationStatus}
          setPrefferedLocations={setPrefferedLocations}
          prefferedLocations={prefferedLocations}
          setCurrentLocationStatus={setCurrentLocationStatus}
          selectedRows={selectedRows}
          setCitySave={setCitySave}
          citySave={citySave}
        />
      </divForm>
    )
  }

  const footer = () => {
    return (
      <FlexWrap gap="20px" right>
        <Button.Secondary text="Cancel" height="38px" onClick={onClose} />
        <Button.Primary
          text={'Preview & Shortlist'}
          onClick={onSubmit}
          icon={<CheckIconWhite />}
          height="38px"
          disabled={
            appliedCandidatesListTrue?.count === 0 ||
            (prefferedlocationStatus && !prefferedLocations?.length)
          }
        />
      </FlexWrap>
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Shortlist'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={shortListDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default ShortListDrawer
